import { Component, OnInit, Input, HostBinding } from '@angular/core';
import { Tier3Service } from '../../../services/obs/tier3.service';
import { urlEndPoint } from 'src/app/common';
import { DomSanitizer } from '@angular/platform-browser';
declare var $;

@Component({
  selector: 'app-carousel-pubs',
  templateUrl: './carousel-pubs.component.html',
  styleUrl: './carousel-pubs.component.scss'
})
export class CarouselPubsComponent implements OnInit {

  /* enviar el id al componente carousel */
  @Input() data: any[] = [];
  @Input() color: string;
  t_color: string = '#3b69ae';
  URL: string = urlEndPoint;
  isUploadDir: boolean = false;
  tier3Data: any[] = null;
  bandSlider: boolean = false;

  constructor(
    private tier3Service: Tier3Service,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    this.loadCarousel();    
  }

  @HostBinding("attr.style")
  public get valueAsStyle(): any {
    return this.sanitizer.bypassSecurityTrustStyle(`--tcolor: ${this.color || this.t_color}`);
  }

  loadCarousel() {
    $('.carousel').carousel({});
  }

  verifiedLength(word: string): boolean {
    if (!word) return false;
    return word.length <= 83;
  }
  
  verifiedImgDirectory(imagen: string): boolean {
    if (!imagen) return false;
    const subcadena = imagen.slice(1, 7);
    return subcadena === 'upload';
  }
}
